/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Research_Limit_2_ValueInputs */

const en_svc_research_limit_2_value = /** @type {(inputs: Svc_Research_Limit_2_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When the sources disagree or run out, the brief says so.`)
};

const lv_svc_research_limit_2_value = /** @type {(inputs: Svc_Research_Limit_2_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja avoti nesaskan vai to trūkst, kopsavilkums to pasaka.`)
};

/**
* | output |
* | --- |
* | "When the sources disagree or run out, the brief says so." |
*
* @param {Svc_Research_Limit_2_ValueInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_research_limit_2_value = /** @type {((inputs?: Svc_Research_Limit_2_ValueInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Research_Limit_2_ValueInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_research_limit_2_value(inputs)
	return en_svc_research_limit_2_value(inputs)
});